<script>
  import VerifyPopup from './organizer/VerifyPopup.svelte';
  import { sendDeleteChatMessage, sendAdminMessage } from '../js/actions.js';
  import { chatState } from '../js/state.js';
  import { clickOutside } from '../js/libs/clickOutside.js';
  import { formatToChatTime } from '../js/libs/datetime.js';
  import { linkify } from '../js/libs/url.js';
  import { sanitize } from '../js/libs/sanitize.js';

  import {
    CHAT_ME,
    CHAT_BAN_THIS_USER,
    CHAT_BAN_THIS_USER_FROM_EVENT,
    CHAT_DELETE_MESSAGE,
    CHAT_MODERATOR,
    CHAT_BAN_USER_CONFIRM_TITLE,
    CHAT_BAN_USER_CONFIRM_DETAILS,
    CHAT_BAN_USER_FROM_EVENT_CONFIRM_TITLE,
    CHAT_BAN_USER_FROM_EVENT_CONFIRM_DETAILS,
    CHAT_FEEDBACK_BANNED_FROM_CHAT,
    CHAT_DELETE_MESSAGE_CONFIRM_TITLE,
    CHAT_DELETE_MESSAGE_CONFIRM_DETAILS,
    CHAT_PIN_MESSAGE,
  } from '../js/l10n/en_US.js';

  export let name,
    msg = {},
    message,
    time,
    sub = '',
    source,
    id,
    drm = false,
    userChatBanned = false,
    isAdmin = false,
    isMe = false,
    isModerator = false,
    showModerateMessage = false,
    onBan = (subject) => {},
    onBanAccess = (subject) => {};

  let popupTitle = '',
    popupDetails = '',
    confirmPopup = () => {},
    popup = false,
    messageLocation = null,
    menuUp = false;

  function banUser() {
    confirmPopup = () => {
      popup = false;
      onBan(source, id, sub, name);
    };
    popupTitle = CHAT_BAN_USER_CONFIRM_TITLE;
    popupDetails = CHAT_BAN_USER_CONFIRM_DETAILS;
    popup = true;
    showModerateMessage = false;
  }

  function banAccess() {
    confirmPopup = () => {
      popup = false;
      onBanAccess(source, id, sub, name);
    };
    popupTitle = CHAT_BAN_USER_FROM_EVENT_CONFIRM_TITLE;
    popupDetails = CHAT_BAN_USER_FROM_EVENT_CONFIRM_DETAILS;
    popup = true;
    showModerateMessage = false;
  }

  function deleteMessage() {
    confirmPopup = () => {
      popup = false;
      sendDeleteChatMessage(source, id, msg.id);
    };
    popupTitle = CHAT_DELETE_MESSAGE_CONFIRM_TITLE;
    popupDetails = CHAT_DELETE_MESSAGE_CONFIRM_DETAILS;
    popup = true;
    showModerateMessage = false;
  }

  function closePopup() {
    popup = false;
  }

  function toggleModerateMessage() {
    try {
      if (
        document.getElementById('live-chat-feed').getBoundingClientRect().bottom -
          messageLocation.getBoundingClientRect().bottom <
        150
      ) {
        menuUp = true;
      }
    } catch (e) {
      console.warn('Issue detecting rect for ban menu', e);
    }
    showModerateMessage = !showModerateMessage;
  }

  function pinExistingMessage() {
    if (!(isModerator || isAdmin)) return;

    sendAdminMessage(source, id, name, message, true, time, true);
  }

  function handleClickOutside(e) {
    setTimeout(function() {
      showModerateMessage = false;
    }, 100);
  }
</script>

{#if popup}
  <VerifyPopup
    title={popupTitle}
    details={popupDetails}
    onClose={closePopup}
    onConfirm={confirmPopup}
    visible
    showCancel={false}
    forceInteraction={true} />
{/if}
<li
  class="chat-message {isMe ? 'chat-message-me' : ''}
  {isModerator ? 'chat-message-moderator' : ''}">
  {#if isModerator}
    <div class="chat-message-content">
      {@html linkify(sanitize(message))}
    </div>
  {:else}
    <div class="chat-message-content">{message}</div>
  {/if}
  {#if isAdmin}
    <span on:click={toggleModerateMessage} class="chat-moderator-dots" bind:this={messageLocation}>
      {#if showModerateMessage}
        <i class="icon-close" />
      {:else}
        <i class="icon-more_horiz" />
      {/if}
    </span>
  {/if}
  <div class="chat-message-time">
    <span class="chat-name-time">
      {isMe ? name + ' (' + CHAT_ME + ')' : name}{isAdmin && isModerator ? ' (' + CHAT_MODERATOR + ')' : ''}
      @ {formatToChatTime(time)}
      {#if userChatBanned}
        <span class="chat-user-banned">{CHAT_FEEDBACK_BANNED_FROM_CHAT}</span>
      {/if}
    </span>
  </div>
  {#if isAdmin && showModerateMessage}
    <div
      class="chat-moderate-message-menu"
      use:clickOutside
      on:click_outside={handleClickOutside}
      style={menuUp ? 'bottom: 15px;' : 'top: 0;'}>
      <div class="pin-area">
        <span class="chat-message-pin" on:click={pinExistingMessage}>
          <i class="icon-pin" />
          {CHAT_PIN_MESSAGE}
        </span>
      </div>
      {#if !isModerator}
        <span class="chat-message-ban" on:click={banUser}>
          <i class="icon-close" />
          {CHAT_BAN_THIS_USER}
        </span>
        {#if drm}
          <span class="chat-message-ban-access" on:click={banAccess}>
            <i class="icon-close" />
            {CHAT_BAN_THIS_USER_FROM_EVENT}
          </span>
        {/if}
      {/if}
      <span class="chat-message-delete" on:click={deleteMessage}>
        <i class="icon-trash-o" />
        {CHAT_DELETE_MESSAGE}
      </span>
    </div>
  {/if}
</li>
